import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import editIcon from "../../../../images/icons/edit.svg";
import trashIcon from "../../../../images/icons/delete.svg";
import DeleteModal from "../../../common/DeleteModal";
import ReviewsService from "../../../../services/ReviewsService";

const CardItem = ({ item, index, setAddModal, setItem, setShouldUpdate }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const navigate = useNavigate();
	const reviewsService = new ReviewsService();
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.roles?.includes(data);
	const lang = useSelector((state) => state.auth?.lang);

	return (
		<tr key={index}>
			<td className="text-wrap-mode">{item[`review_${lang}`]}</td>
			<td className="text-wrap-mode">{item[`name_${lang}`] || "-"}</td>
			<td className="text-wrap-mode">{item?.no_of_stars}</td>
			<td>
				<div className="d-flex" style={{ gap: "20px" }}>
					{isExist("update_reviews") && (
						<img
							src={editIcon}
							onClick={() => {
								setItem(item);
								setAddModal(true);
							}}
							className="cursor-pointer"
							alt="edit"
							width={24}
						/>
					)}
					{isExist("delete_reviews") && (
						<img
							src={trashIcon}
							onClick={() => setDeleteModal(true)}
							className="cursor-pointer"
							alt="trash"
							width={24}
						/>
					)}
				</div>
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={lang === "en" ? item?.review_en : item?.review_ar}
					deletedItem={item}
					modelService={reviewsService}
					setShouldUpdate={setShouldUpdate}
					onCloseModal={setDeleteModal}
				/>
			)}
		</tr>
	);
};
export default CardItem;
